export default __webpack_public_path__ + "static/media/parking.ffef27ef.png";